import React, { Component, Fragment } from "react"
import { observer } from "mobx-react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Card, Icon, Button, Input, Label, Reveal, Image, Dropdown } from "semantic-ui-react"
import Price from "components/Price/Price"
import ButtonLove from "components/Button/ButtonLove"
import shop from "shop/shop"
import "components/Product/ProductCard.scss"
import Responsive from "react-responsive"
import ImageWithFallback from "components/ImageWithFallback"
import Badge from "components/Product/Badge";
import OrderModel   from "shop/OrderModel";
import ProductPrice from "components/Product/ProductPrice";
import { trackAddToCart } from "components/tracking/Tracking";

let orders = []
let ordersWithOpenPositions = []
let openPositions = []
let current = 0

@observer
class ProductCard extends Component {
  

  state = {
    count: 1,

  }

  loadMore = () => {
		let pageSize = 20
		let start = current
		current = current + pageSize
		this.setState( { loading: true } )
		shop.fetch( `/shop/rest/data/orders?start=${start}&count=${pageSize}&open=0` )
			.then( res => {
			  //console.log( "FROM API", { res } )
			  orders = orders.concat( res.values.map( data => new OrderModel( data ) ) )
			  openPositions = []
			  // find orders with Open Positions
			  let orderOpen = orders.filter( order => {
				return order.positions.filter( product => {
				  let hasOpen = product.open && product.open !== 0
				  if ( hasOpen ) {
					openPositions.push( product )
				  }
				  return hasOpen
				} ).length
			  } )
			  
		  
			  this.setState( { orderOpen, loading: false } )
			  if ( res.values.length === 0 ) {
				this.setState( { noMoreOrders: true } )
			  }
			} )
	  }
	
	  loadSession = ( session ) => {
		this.setState( { noMoreOrders: false } )
	  }
	  componentDidMount() {
		orders = []
		ordersWithOpenPositions = []
		openPositions = []
		current = 0
		shop.events.authentified.add( this.loadSession )
		// this.loadSession()
	  }
  
  render() {
    let { product, categoryId = "" } = this.props
    const inCart = shop.cart.productsById.get( product.map_id )
    const useQuickorder = shop.config.plugin.orderFromTile && shop.session
    
    
    if ( !product ) return <div>LOADING</div>

    let articleOpen = 0		
		if(openPositions){
			if(openPositions.length > 0){
				//console.log("HASOPEN:", openPositions[0].article_nr)
				//console.log("HASOPEN:", product.article_nr)
				for(let i = 0; openPositions.length > i;i++){
					if(openPositions[i].article_nr == product.article_nr){
						//console.log("hasopenpassig")
						articleOpen = 1
					}
				}
			}
			
		}
    
    return (<Fragment>
        <Responsive minWidth={1100}>
                <Card style={{height: "550px"}}
        className="product ProductCard hide-child ">
        <div className="wrapper relative" style={{height: "550px"}}>
          {/* CARD B: NOT HOVER */}
          {/*<pre className="absolute top-0 left-0 right-0 f6 bg-black white">{JSON.stringify( {sort: product.sort}, null, 2 )}</pre>*/}
          <br/><br/>
           {/*!shop.session && <div className="porductCardCallTActionDiv">
              <Button id="porductCardCallTActionButton" style={{borderRadius: "35px"}} primary>{translate("Login für Preise")} </Button>

            </div>*/}
          <Link className="product-inner"
                to={`/product/${product.map_id}/?category=${categoryId}`}>
            <div className="image flex items-center justify-center pt6">
              <ImageWithFallback
                fallback={"/image/placeholder.png"}
                src={product.img_src_medium}
                alt={product.title}
                title=""
                className="img-responsive"/>
            </div>
            <div className="caption pt6 pl2 pr2">
              <div className="f5 fw7 black-90 pt3" title={product.title}>{product.title}</div>
              <div className="category black-50 f6" title={product.category.title}>
								{<div> #{product.article_nr} </div>}
                <span><ProductPrice className={"f2 pb4 pt3 relative lh-solid"} productCard={true} product={product} /></span>
              </div>
              
              {/*{(inCart && inCart.count > 0) && <div className="absolute top-1 left-1 f6 black-40 ">*/}
              {/*  <Icon name={"shopping cart"}/> {inCart.count * inCart.unit_multi} Stück*/}
              {/*</div>}*/}
              
              <div className="actions">
                {(this.props.list) ? <ButtonLove list={this.props.list}
                                                 product={product}><Icon
                  name={"heart"}/></ButtonLove> : null} </div>
            
            </div>
          </Link>
          
          <div className="absolute top-1 right-1">
            <ButtonLove list={shop.orderlist.default}
                        className="dib mr3"
                        elementInActive={<span><Icon name={"large  heart outline"}/></span>}
                        elementActive={<span><Icon name={"large  heart"}/></span>}
                        product={product}/>
          </div>
          
          
          {this.props.children}
          
          <div className="badges absolute left-1 top-1 black-50 ">
          
            {product.extraValue.new && <div className=" pb2"><Label color="red"><span className="ttu">{translate( "Neu" )}</span></Label></div>}
            <div className="flex flex-row">
              {/*{product.extras.gc_rabatt && <Label className={"giftcardPercent"} color="red">COUPON {product.extras.gc_rabatt} %</Label>}*/}
              {/*product.pinfos.gc_rabatt && <div title={translate("Coupon-Rabatt")} className="mr1 pb2"><Label className={"giftcardPercent"} color="red"><span className="ttu">-{product.pinfos.gc_rabatt} %</span></Label></div>*/}
              {/*product.isSale && <div title={translate("Ihr Kundenrabatt")} className="pb2"><Label className={"salePercent"} color="blue">{translate("Sale!")}</Label></div>*/}
            </div>
            <div className="flex flex-row items-center pt3">
              <div className="availability tl">{product.getNotice( "tiny", Number( product.stock ) )}</div>
              <Badge product={product}/>
            
            </div>
            {!shop.session && product.extras.auslauf && product.extras.auslauf.value.value == "yes" && <Label color="#2d373b">{translate("Auslaufartikel")}</Label>}
            {product.cats[1] && product.cats[1].cat_id == 'NEU' && <a className="labelNeu1">&nbsp;&nbsp;{translate("Neu!")}&nbsp;&nbsp;</a>}
            {product.cats[0] && product.cats[0].cat_id == 'NEU' && <a className="labelNeu1">&nbsp;&nbsp;{translate("Neu!")}&nbsp;&nbsp;</a>}
            {product.isSale && product.pinfos.sale_percent && <a className="labelNeu1">&nbsp;&nbsp;{translate("Sale!")}&nbsp;&nbsp;</a>}
            {articleOpen == 1 && <a className="labelNeu">&nbsp;&nbsp;{translate("Rückstand")}&nbsp;&nbsp;</a>}
						{/*product.isSale && <Label color="blue">{translate("Sale!")}</Label>*/}
            {shop.session &&product.extras.auslauf && product.extras.auslauf.value.value == "yes" && <Label color="#2d373b">{translate("Auslaufartikel")}</Label>}

            {/*TODO: TEST VISUALLY */}
            {/*{inCart ? <div className={"white"}><Icon name="shopping cart"/> {inCart.count * inCart.unit_multi} Stück</div>*/}
            {/*  : <div><Icon name="shopping cart"/> 0 Stück</div>*/}
            {/*}*/}
            
          </div>
          <div className="">
                  <div className="absolute bottom-0 left-1 right-1 flex flex-row items-between justify-between pb3 pt3 ">
                  {product &&
                    <Input style={{borderRadius: "35px", height: "40px"}} className="transparent ba b--black-20 bw1 pr3 pl3 mt2" type="number" min={Number(product.pinfos.minbuy) != 0 ? Number(product.pinfos.minbuy) : 1} placeholder={product.count || 1} 
                      defaultValue={1} 
                      value={this.state.count}
                      action 
                      onChange={e => {
                        this.setState({ count: e.target.value });
                      }}
                      onBlur={e => {
                        if (Number(e.target.value) < Number(product.pinfos.minbuy)) {
                        shop.toast(translate(`Mindestbestellmenge wurde korrigiert.`), "warning", false, "top");
                        e.target.value = Number(product.pinfos.minbuy);
                        this.setState({ count: e.target.value });
                          
                        }
                      }}>
                      
                      <Responsive minWidth={790}>
                      <Button style={{borderRadius: "35px", backgroundColor: "#ffffff", width: "30px"}} icon="minus" onClick={() => {
                        let newCount = Math.max((this.state.count ||  1) - 1);
                        if(newCount < 1){
                          newCount = 1

                        }
                        //console.log("newCount",newCount)
                        this.setState({ count: newCount });
                      }} />
                        <input style={{ width: "50px", height: "40px", textAlign: "center", border: "none"}} onFocus={(e) => e.target.style.outline = "none"} defaultValue={1} 
                      value={this.state.count}                       onChange={e => { this.setState({ count: e.target.value }); }}  />
                        <Button style={{borderRadius: "35px", backgroundColor: "#ffffff", width: "30px" }} className="mr2" icon="plus" onClick={() => {
                        let newCount = (this.state.count ||  1) + 1;
                        //console.log("newCount",newCount)
                        this.setState({ count: newCount });
                      }} /></Responsive>
                      <Responsive maxWidth={789}>
                      <Button style={{borderRadius: "35px", backgroundColor: "#ffffff", width: "20px"}} icon="minus" onClick={() => {
                        let newCount = Math.max((this.state.count ||  1) - 1);
                        if(newCount < 1){
                          newCount = 1

                        }
                        //console.log("newCount",newCount)
                        this.setState({ count: newCount });
                      }} />
                        <input style={{ width: "30px", height: "40px", textAlign: "center", border: "none"}} onFocus={(e) => e.target.style.outline = "none"} />
                        <Button style={{borderRadius: "35px", backgroundColor: "#ffffff", width: "20px" }} className="mr2" icon="plus" onClick={() => {
                        let newCount = (this.state.count ||  1) + 1;
                        //console.log("newCount",newCount)
                        this.setState({ count: newCount });
                      }} /></Responsive>
                      {/*<Select key={product.map_id} compact options={veOptions} defaultValue={product.quantities && product.quantities[ 0 ].map_desc_id}
                          onChange={( e, data ) => {
                            const { value } = data
                            const ve = product.quantities.filter( q => q.map_desc_id === value )
                            if ( !ve ) return
                            product.unit_multi = ve[ 0 ].multi
                            product.unit_id = ve[ 0 ].map_desc_id
                            console.log( { data, e, value: e.target.value, target: e.target } )
                          }
                          }
                      />*/}


                  </Input>}
                
                {<Button style={{borderRadius: "35px", backgroundColor: "#ffffff", color: "#a2cf66"}} icon="big cart" onClick={() => {
                if(!shop.session){
                  document.location = `/login/?referrer=${document.location.pathname}?login`
                }
                let { count } = this.state
                product.count = count
                //console.log("product",product)
                shop.cart.add( product )
                trackAddToCart(product.map_id, product.title)
                shop.toast( `${product.count} ${translate(product.unit_desc)} x ${product.title} ${translate("im Warenkorb")}`, "neutral", false, "bottom" )
              }} />}
              </div>
        </div>
        </div>
        </Card>
        </Responsive>
        <Responsive maxWidth={1099}>
          <div className="pa3">
                <Card style={{minHeight: "550px", maxHeight: "550px", minWidth: "350px"}}
        className="product ProductCard hide-child ">
        <div className="wrapper relative tc"  style={{height: "550px", width: ""}}>
          {/* CARD B: NOT HOVER */}
          {/*<pre className="absolute top-0 left-0 right-0 f6 bg-black white">{JSON.stringify( {sort: product.sort}, null, 2 )}</pre>*/}
          <br/><br/>
          <Link className="product-inner"
                to={`/product/${product.map_id}/?category=${categoryId}`}>
            <div className="image flex items-center justify-center pt6">
              <ImageWithFallback
                fallback={"/image/placeholder.png"}
                src={product.img_src_medium}
                alt="..."
                title=""
                className="img-responsive"/>
            </div>
            <div className="caption pt6">
              <div className="f5 fw7 black-90 pt3" title={product.title}>{product.title}</div>
              <div className="category black-50 f6" title={product.category.title}>
                {/*<div> #{product.article_nr.substring(0,product.article_nr.length-8)} </div> */}
								{<div> #{product.article_nr} </div>}
                <div className="tc"><ProductPrice className={"f2 pb2 pt3  relative lh-solid"} productCard={true} product={product} /></div>
              </div>
              
              {/*{(inCart && inCart.count > 0) && <div className="absolute top-1 left-1 f6 black-40 ">*/}
              {/*  <Icon name={"shopping cart"}/> {inCart.count * inCart.unit_multi} Stück*/}
              {/*</div>}*/}
              
              <div className="actions">
                {(this.props.list) ? <ButtonLove list={this.props.list}
                                                 product={product}><Icon
                  name={"heart"}/></ButtonLove> : null} </div>
            
            </div>
          </Link>
          
          <div className="absolute top-1 right-1">
            <ButtonLove list={shop.orderlist.default}
                        className="dib mr3"
                        elementInActive={<span><Icon name={"large  heart outline"}/></span>}
                        elementActive={<span><Icon name={"large  heart"}/></span>}
                        product={product}/>
          </div>
          
          
          {this.props.children}
          
          <div className="badges absolute left-1 top-1 black-50 ">
          
            {product.extraValue.new && <div className=" pb2"><Label color="red"><span className="ttu">{translate( "Neu" )}</span></Label></div>}
            <div className="flex flex-row">
              {/*{product.extras.gc_rabatt && <Label className={"giftcardPercent"} color="red">COUPON {product.extras.gc_rabatt} %</Label>}*/}
              {/*product.pinfos.gc_rabatt && <div title={translate("Coupon-Rabatt")} className="mr1 pb2"><Label className={"giftcardPercent"} color="red"><span className="ttu">-{product.pinfos.gc_rabatt} %</span></Label></div> */}
              {/*product.isSale && <div title={translate("Ihr Kundenrabatt")} className="pb2"><Label className={"salePercent"} color="blue">{translate("Sale!")}</Label></div>*/}
            </div>
            <div className="flex flex-row items-center pt3">
              <div className="availability tl">{product.getNotice( "tiny", Number( product.stock ) )}</div>
              <Badge product={product}/>
            </div>
            {!shop.session && product.extras.auslauf && product.extras.auslauf.value.value == "yes" && <Label color="#2d373b">{translate("Auslaufartikel")}</Label>}
            {product.cats[1] && product.cats[1].cat_id == 'NEU' && <a className="labelNeu1">&nbsp;&nbsp;{translate("Neu!")}&nbsp;&nbsp;</a>}
            {product.cats[0] && product.cats[0].cat_id == 'NEU' && <a className="labelNeu1">&nbsp;&nbsp;{translate("Neu!")}&nbsp;&nbsp;</a>}
            {product.isSale && product.pinfos.sale_percent && <a className="labelNeu1">&nbsp;&nbsp;{translate("Sale!")}&nbsp;&nbsp;</a>}
            {articleOpen == 1 && <a className="labelNeu">&nbsp;&nbsp;{translate("Rückstand")}&nbsp;&nbsp;</a>}
						{/*product.isSale && <Label color="blue">{translate("Sale!")}</Label>*/}
            {shop.session &&product.extras.auslauf && product.extras.auslauf.value.value == "yes" && <Label color="#2d373b">{translate("Auslaufartikel")}</Label>}

            {/*TODO: TEST VISUALLY */}
            {/*{inCart ? <div className={"white"}><Icon name="shopping cart"/> {inCart.count * inCart.unit_multi} Stück</div>*/}
            {/*  : <div><Icon name="shopping cart"/> 0 Stück</div>*/}
            {/*}*/}
          </div>
          <div className="pt2">

          <div className="absolute bottom-0 left-1 right-1 flex flex-row items-between justify-between pb3 pt3 ">
                                    {product &&
                    <Input style={{borderRadius: "35px", height: "40px"}} className="transparent ba b--black-20 bw1 pr3 pl3 mt2" type="number" min={Number(product.pinfos.minbuy) != 0 ? Number(product.pinfos.minbuy) : 1} placeholder={product.count || 1} 
                      defaultValue={1} 
                      value={this.state.count}
                      action 
                      onChange={e => {
                        this.setState({ count: e.target.value });
                      }}
                      onBlur={e => {
                        if (Number(e.target.value) < Number(product.pinfos.minbuy)) {
                        shop.toast(translate(`Mindestbestellmenge wurde korrigiert.`), "warning", false, "top");
                        e.target.value = Number(product.pinfos.minbuy);
                        this.setState({ count: e.target.value });
                          
                        }
                      }}>
                      
                      <Responsive minWidth={790}>
                      <Button style={{borderRadius: "35px", backgroundColor: "#ffffff", width: "30px"}} icon="minus" onClick={() => {
                        let newCount = Math.max((this.state.count ||  1) - 1);
                        if(newCount < 1){
                          newCount = 1

                        }
                        //console.log("newCount",newCount)
                        this.setState({ count: newCount });
                      }} />
                        <input style={{ width: "70px", height: "40px", textAlign: "center", border: "none"}} onFocus={(e) => e.target.style.outline = "none"} defaultValue={1} 
                      value={this.state.count}                       onChange={e => { this.setState({ count: e.target.value }); }}  />
                        <Button style={{borderRadius: "35px", backgroundColor: "#ffffff", width: "30px" }} className="mr2" icon="plus" onClick={() => {
                        let newCount = (this.state.count ||  1) + 1;
                        //console.log("newCount",newCount)
                        this.setState({ count: newCount });
                      }} /></Responsive>
                      <Responsive maxWidth={789}>
                                            <Button style={{borderRadius: "35px", backgroundColor: "#ffffff", width: "30px"}} icon="minus" onClick={() => {
                        let newCount = Math.max((this.state.count ||  1) - 1);
                        if(newCount < 1){
                          newCount = 1

                        }
                        //console.log("newCount",newCount)
                        this.setState({ count: newCount });
                      }} />
                        <input style={{ width: "50px", height: "40px", textAlign: "center", border: "none"}} onFocus={(e) => e.target.style.outline = "none"} defaultValue={1} 
                      value={this.state.count}                       onChange={e => { this.setState({ count: e.target.value }); }}  />
                        <Button style={{borderRadius: "35px", backgroundColor: "#ffffff", width: "30px" }} className="mr2" icon="plus" onClick={() => {
                        let newCount = (this.state.count ||  1) + 1;
                        //console.log("newCount",newCount)
                        this.setState({ count: newCount });
                      }} /></Responsive>
                  </Input>}
                {<Button style={{borderRadius: "35px", backgroundColor: "#ffffff", color: "#a2cf66"}} icon="big cart" onClick={() => {
                if(!shop.session){
                  document.location = `/login/?referrer=${document.location.pathname}?login`
                }
                let { count } = this.state
                product.count = count
                //console.log("product",product)
                shop.cart.add( product )
                trackAddToCart(product.map_id, product.title)
                shop.toast( `${product.count} ${translate(product.unit_desc)} x ${product.title} ${translate("im Warenkorb")}`, "neutral", false, "bottom" )
              }} />}
              </div>
        </div>
        </div>
        </Card>
        </div>
        </Responsive>

        
        
        {/*CARD A:  ON HOVER */}
        {useQuickorder && <div className="hover-card pa3 child absolute left-0 right-0 top-0 bottom-0  z-9  bg-darken">
          
          <div className="">
            
            <div className="absolute top-1 right-1">
              <ButtonLove list={shop.orderlist.default}
                          className="dib mr3 f4"
                          elementInActive={<span><Icon name={"heart"}/></span>}
                          elementActive={<span><Icon name={"heart"}/></span>}
                          product={product}/>
            </div>
            
            
            <div className="tc product-link">
              <Button circular as={Link} to={`/product/${product.map_id}/?category=${categoryId}`}>zum
                Produkt</Button>
            </div>
            
            <div className="bottom-drawer absolute bottom-0 left-0 right-0 bg-white  fadeIn">
              
              <div className="pa3 absolute bottom-0 left-0 right-0">
                <CardOrder product={product} onChange={() => {
                  this.setState( {} )
                }}/>
              </div>
            </div>
          </div>
        
        </div>}
      </Fragment>
    )
  }
}


@observer
class CardOrder extends Component {
  
  state = {
    count: 0,
    quantity: this.props.product.quantities[ 0 ],
    isAdded: false,
    loading: false,
  }
  
  setQuantity( quantity ) {
    this.setState( { quantity }, this.toCart )
  }
  
  setCount( count ) {
    count = Math.max( 0, count )
    this.setState( { count }, this.toCart )
  }
  
  toCart = () => {
    let { quantity, count, isAdded } = this.state
    let { product } = this.props
    if ( count > 0 ) {
      product.count = count
      product.unit_id = quantity.map_desc_id
      product.unit_multi = quantity.multi
      shop.cart.add( product )
      trackAddToCart(product.map_id, product.title)
      shop.toast( `${product.count}x${product.unit_multi} Stk. ${product.title} ${translate("im Warenkorb")}`, "neutral", false, "bottom" )
      this.setState( { product, isAdded: true } )
      this.props.onChange && this.props.onChange( { product } )
    } else {
      shop.cart.remove( product )
    }
  }
  
  render() {
    let { quantity, count, isAdded } = this.state
    let { product } = this.props
    const inCart = shop.cart.productsById.get( product.map_id )
    
    if ( !product.canBeBought ) return <div>{translate( "Nicht verfügbar" )}</div>
    return <div className={`CardOrder pt3 ${inCart ? "inCart" : ""}`}>
      
      <div className="labels ">
      </div>
      
      
      <div className="pb3 tc f5-ns f7">
        <Responsive minWidth={"560px"}>
          {product.quantities.length > 3 ?
            <Dropdown
              selection
              fluid
              value={quantity}
              onChange={( e, data ) => {
                this.setQuantity( data.value )
              }}
              options={product.quantities.map( q => {
                return {
                  key: q.multi,
                  text: `${q.des} (${q.multi})`,
                  value: q
                }
              } )}
            />
            :
            <Button.Group className="quantities" basic size="tiny">
              {product.quantities.map( q => {
                return <Button
                  active={quantity.map_desc_id === q.map_desc_id}
                  key={q.map_desc_id}
                  onClick={() => {
                    this.setQuantity( q )
                    // this.setState( { quantity: q } )
                  }
                  }>{`${q.des} (${q.multi})`}</Button>
              } )}
            </Button.Group>
          }
        
        </Responsive>
        
        <Responsive maxWidth={"559px"}>
          <Dropdown
            selection
            fluid
            value={quantity}
            onChange={( e, data ) => {
              // this.setState( { quantity: data.value } )
              this.setQuantity( data.value )
            }}
            options={product.quantities.map( q => {
              return {
                key: q.multi,
                text: `${q.des} (${q.multi})`,
                value: q
              }
            } )}
          />
        </Responsive>
      
      
      </div>
      
      <div className="flex flex-auto w-100  QuickorderTab" style={{ justifyContent: "space-between" }}>
        <Button circular basic floated="right" icon="minus" onClick={() => {
          if ( product.count > 0 ) {
            count -= 1
          } else {
            count = 0
          }
          this.setCount( count )
        }
        }/>
        
        <div className="quickorder-input ">
          <Input type="number" value={count} onChange={e => {
            let count = Math.max( 0, Number( e.target.value ) )
            this.setCount( count )
          }}/>
        </div>
        
        <Button circular basic floated="right" icon="plus" onClick={() => {
          if ( count ) {
            count += 1
          } else {
            count = 1
          }
          
          this.setCount( count )
        }
        }/>
      </div>
      
      {/*<div className="tc">*/}
      {/*  <Button*/}
      {/*    color={isAdded ? "green" : "blue"}*/}
      {/*    circular fluid*/}
      {/*    onClick={() => {*/}
      {/*      console.log( "adding", { state: this.state } )*/}
      {/*      this.toCart()*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    {isAdded && <div className={"animate fadeInUp"}>Hinzugefügt</div>}*/}
      {/*    {!isAdded && <span> In den Warenkorb</span>}*/}
      {/*  </Button>*/}
      {/*</div>*/}
    </div>
  }
}

CardOrder.propTypes = { product: PropTypes.any }


ProductCard.defaultProps = {
  quickorder: false
}

ProductCard.propTypes = {
  quickorder: PropTypes.any,
  list: PropTypes.object,
  product: PropTypes.object,
  xs: PropTypes.string,
  sm: PropTypes.string,
  md: PropTypes.string,
  lg: PropTypes.string,
}

export default ProductCard



// WEBPACK FOOTER //
// ./src/theme/demo2025/components/Product/ProductCard.js